import AsyncStorage from '@react-native-async-storage/async-storage';
import _ from 'lodash'
import { localeSettingConstantsToState, localeSettingsDefaultValues } from 'utils/constants/LocaleSettings'
import store from 'services/redux/store';
import { setData } from "services/redux/data/actions";

export default class HelperLocaleSettings{
	static settingsIdentifier = '@mod_settings';
	static settings = null;
	
	static load = async() => {
		if( _.isEmpty( this.settings ) ){
			let settings = await AsyncStorage.getItem( this.settingsIdentifier );
			
			if( settings === null || settings === 'null' ) {
				this.settings = {};
				return null;
			}
			
			this.settings = JSON.parse( settings ); // load here
			
			// write to state where required
			_.forEach( this.settings, ( value, key ) => {
				// Write to store
				this.writeToStore( key, value );
			});
		}
	}
	
	static save = () => {
		AsyncStorage.setItem( this.settingsIdentifier, JSON.stringify( this.settings ) );
	}
	
	static get = ( key, fallback = null ) => {
		return _.get( this.settings, key, fallback !== null ? fallback : _.get( localeSettingsDefaultValues, key, null ) );
	}
	
	static set( key, value ){
		// Write to local variable
		this.settings[ key ] = value;
		
		// Write to store
		this.writeToStore( key, value );
		
		// Save to localeStorage
		this.save();
	}
	
	static writeToStore( key, value ){
		// Write to state if required
		let storeDataKey = _.get( localeSettingConstantsToState, key, false );
		
		if( storeDataKey !== false ){
			store.dispatch( setData( storeDataKey, value ) );
		}
		
	}
}
